import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import SoberLivingFormModal from "./SoberLivingFormModal";
import moment from "moment";

class SoberLivingList extends Component {
  render() {
    const { soberLivings, action, isStaffApp, newSoberLiving, editSoberLiving } = this.props
    return (
      <div>
        <SoberLivingFormModal />
        <Table size="sm" responsive>
          <thead>
            <tr>
              <th>Facility Name</th>
              <th>Length of Stay</th>
              <th>Admitted At</th>
              <th>Discharged At</th>
              <th>Reason for Discharge</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              this.props.soberLivings.map((soberLiving) => {
                return (
                  <tr key={soberLiving.id}>
                    <td>{soberLiving.name}</td>
                    <td>
                      {
                        soberLiving.admitted_at &&
                        `${moment(soberLiving.discharged_at || moment()).diff(moment(soberLiving.admitted_at), 'days')} days`
                      }
                    </td>
                    <td>{soberLiving.admitted_at && moment(soberLiving.admitted_at).format("MM/DD/YYYY")}</td>
                    <td>{soberLiving.discharged_at && moment(soberLiving.discharged_at).format("MM/DD/YYYY")}</td>
                    <td>{soberLiving.reason_for_discharge}</td>
                    <td>
                      {
                        this.props.action === "edit" &&
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.props.editSoberLiving(soberLiving);
                          }}>
                          Edit
                        </a>
                      }
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </Table>
        <div className="d-flex justify-content-center">
          {
            this.props.action === "edit" &&
            <Button
              variant="link"
              onClick={() => {
                this.props.newSoberLiving();
              }}>
              Add Sober Living
            </Button>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    soberLivings: state.sober_livings,
    isStaffApp: state.config.isStaffApp,
    action: state.ui.action
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newSoberLiving: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "soberLiving" }
      })
    },
    editSoberLiving: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: {
          resourceName: "soberLiving",
          resource
        }
      })
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SoberLivingList);
